<div *ngIf="control" class="form-group">
	<ng-container *ngIf="!!labelText">
		<label class="mb-2" [for]="formControlName">{{ labelText }}</label>
		<span *ngIf="!isRequired" class="optional-field">
			({{ "GLOBAL.OPTIONAL_FIELD" | translate }})
		</span>

		@if (!!tooltipText) {
			<span class="align-text-top cursor-pointer">
				<atlas-icon
					name="info"
					size="2x"
					[attr.tooltip]="tooltipText"
					theme="primary"
				></atlas-icon>
			</span>
		}

		@if (!!popoverText) {
			<span class="align-text-top cursor-pointer">
				<atlas-icon
					name="info"
					size="2x"
					[attr.tooltip]="popoverText"
					tooltip-trigger="click"
					theme="primary"
				></atlas-icon>
			</span>
		}
	</ng-container>

	<ng-container *ngIf="isInputDate">
		<div [class.input-group]="showClearInputDate">
			<input
				[formControl]="control"
				[type]="type"
				[class.input-date]="showClearInputDate"
				class="form-control"
				[id]="formControlName"
				aria-describedby="atlasInput"
				[placeholder]="placeholderText"
				[autocomplete]="autocomplete"
				bsDatepicker
				[bsConfig]="bsDateConfig"
				[minDate]="minDate"
				readonly
			/>
			<span
				*ngIf="showClearInputDate"
				class="input-group-text input-group-date"
				[class.input-date-disabled]="isDisabled"
			>
				<i
					(click)="resetInput()"
					*ngIf="isControlDirty()"
					class="bi bi-x cursor-pointer"
				></i>
			</span>
		</div>
	</ng-container>

	<ng-container *ngIf="!isInputDate">
		<div
			[class.input-group]="
				!!inputGroupIcon ||
				!!inputGroupIconText ||
				leftInputGroup ||
				rightInputGroup
			"
		>
			<span
				*ngIf="
					!!inputGroupIconText && inputGroupIconPosition === 'left'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				{{ inputGroupIconText }}
			</span>
			<span
				*ngIf="
					!!inputGroupIcon &&
					!inputGroupIconText &&
					inputGroupIconPosition === 'left'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				<i [class]="inputGroupIcon"></i>
			</span>

			<ng-container [ngTemplateOutlet]="leftInputGroup"></ng-container>

			<input
				[formControl]="control"
				[type]="type"
				[class.is-invalid]="errors && control.dirty"
				class="form-control"
				[id]="formControlName"
				aria-describedby="atlasInput"
				[placeholder]="placeholderText"
				[autocomplete]="autocomplete"
				[mask]="mask"
				thousandSeparator=""
			/>

			<ng-container *ngIf="loading && inputGroupIconPosition !== 'right'">
				<div class="position-absolute loader-container">
					<i class="position-relative loader"></i>
				</div>
			</ng-container>

			<ng-container [ngTemplateOutlet]="rightInputGroup"></ng-container>

			<span
				*ngIf="
					!!inputGroupIconText && inputGroupIconPosition === 'right'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				{{ inputGroupIconText }}
			</span>
			<span
				*ngIf="
					!!inputGroupIcon &&
					!inputGroupIconText &&
					inputGroupIconPosition === 'right'
				"
				class="input-group-text"
				id="basic-addon2"
			>
				<i [class]="inputGroupIcon"></i>
			</span>
		</div>
	</ng-container>
	<ng-container *ngIf="!!smallText">
		<small [id]="formControlName" class="form-text text-muted small-text">{{
			smallText
		}}</small>
	</ng-container>

	<ng-container *ngIf="showErrors">
		<app-validation-errors
			[abstractControl]="control"
		></app-validation-errors>
	</ng-container>
</div>
